import { SvgIconType } from './svg.interface';

const ChevronRight: SvgIconType = ({
  width = 12,
  height = 12,
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.96987 1.80651C3.67671 1.51334 3.67671 1.03803 3.96987 0.744867C4.26304 0.451703 4.73835 0.451703 5.03152 0.744867L9.75631 5.46966C10.0492 5.76256 10.0492 6.23743 9.75631 6.53032L5.03152 11.2551C4.73835 11.5483 4.26304 11.5483 3.96987 11.2551C3.67671 10.962 3.67671 10.4866 3.96987 10.1935L8.16336 5.99999L3.96987 1.80651Z"
      fill="#30313D"
    />
  </svg>
);

export default ChevronRight;
